import {
  ButtonsModule,
  ColorModule,
  DatepickerModule,
  MapsAngularComponentsModule,
  NotificationsModule,
  PaginationMapsModule,
} from "maps-angular-components";

import {AsyncButtonDirective} from "./form/asyn-button.directive";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {CabecalhoOrdenavelComponent} from "./cabecalho-ordenavel/cabecalho-ordenavel.component";
import {CollapseModule} from "ngx-bootstrap";
import {CommonModule} from "@angular/common";
import {ComponentSelectorService} from "./modal-detalhe-alteracoes/component-selector.service";
import {ConstantsService} from "./services/constants.service";
import {DigitOnlyDirective} from "./digit-only.directive";
import {DragDropDirective} from "./directives/drag-drop.directive";
import {ExpandibleTitleComponent} from "./menu-expadivel/menu-expadivel.component";
import {ExportButtonComponent} from "./form/export-button.component";
import {FooterComponent} from "./layout/footer/footer.component";
import {HeaderComponent} from "./layout/header/header.component";
import {LoadingIconComponent} from "./loading-icon/loading-icon.component";
import {MatButtonModule} from "@angular/material/button";
import {MatChipsModule} from "@angular/material/chips";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDialogModule} from "@angular/material/dialog";
import {MatDividerModule} from "@angular/material/divider";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatMenuModule} from "@angular/material/menu";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {ModalAssociacaoComponent} from "./modal-detalhe-alteracoes/modal-associacao/modal-associacao.component";
import {ModalCarteiraComponent} from "./modal-detalhe-alteracoes/modal-carteira/modal-carteira.component";
import {ModalConfirmComponent} from './components/modal-confirm/modal-confirm.component';
import {ModalDetalheAlteracoesComponent} from "./modal-detalhe-alteracoes/modal-detalhe-alteracoes.component";
import {ModalRegraComponent} from './modal-detalhe-alteracoes/modal-regra/modal-regra.component';
import {
  ModalRegraCompostaComponent
} from './modal-detalhe-alteracoes/modal-regra-composta/modal-regra-composta.component';
import {NgModule} from "@angular/core";
import {PipesModule} from "./pipes/pipes.module";
import {ReactiveFormsModule} from "@angular/forms";
import {SideMenuModule} from "./layout/sidemenu/sidemenu.module";
import {TotalTableComponent} from "./total-table/total-table.component";
import {ModalImportacaoLoteComponent} from './modal-importacao-lote/modal-importacao-lote.component';
import {ImportacaoLoteComponent} from "./importacao-lote/importacao-lote.component";
import {MatInputModule} from "@angular/material/input";
import {MapsCheckboxComponent} from "./maps-checkbox/maps-checkbox.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ModalDetalheProcessamentoComponent} from './modal-detalhe-processamento/modal-detalhe-processamento.component';
import {
  ModalUltimosDezProcessamentoComponent
} from './modal-ultimos-dez-processamento/modal-ultimos-dez-processamento.component';
import {
  ModalGrupoCarteiraComponent
} from "./modal-detalhe-alteracoes/modal-grupo-carteira/modal-grupo-carteira.component";
import {
  ModalAssociacaoGrupoCarteiraComponent
} from "./modal-detalhe-alteracoes/modal-associacao-grupo-carteira/modal-associacao-grupo-carteira.component";


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoadingIconComponent,
    ExpandibleTitleComponent,
    ExportButtonComponent,
    AsyncButtonDirective,
    TotalTableComponent,
    DigitOnlyDirective,
    CabecalhoOrdenavelComponent,
    ModalDetalheAlteracoesComponent,
    ModalAssociacaoComponent,
    ModalCarteiraComponent,
    ModalRegraCompostaComponent,
    ModalRegraComponent,
    ModalConfirmComponent,
    DragDropDirective,
    ModalImportacaoLoteComponent,
    ImportacaoLoteComponent,
    ModalDetalheProcessamentoComponent,
    ModalUltimosDezProcessamentoComponent,
    MapsCheckboxComponent,
    ModalDetalheProcessamentoComponent,
    ModalGrupoCarteiraComponent,
    ModalAssociacaoGrupoCarteiraComponent
  ],
  imports: [
    CommonModule,
    SideMenuModule,
    ButtonsModule,
    MapsAngularComponentsModule,
    BrowserAnimationsModule,
    NotificationsModule,
    PipesModule,
    BsDropdownModule.forRoot(),
    ColorModule,
    CollapseModule,
    MatFormFieldModule,
    MatSelectModule,
    MatChipsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatMenuModule,
    DatepickerModule,
    PaginationMapsModule,
    MatCheckboxModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LoadingIconComponent,
    AsyncButtonDirective,
    ExportButtonComponent,
    ExpandibleTitleComponent,
    TotalTableComponent,
    DigitOnlyDirective,
    CabecalhoOrdenavelComponent,
    ModalDetalheAlteracoesComponent,
    DragDropDirective,
    ImportacaoLoteComponent,
    MapsCheckboxComponent
  ],
  providers: [ComponentSelectorService, ConstantsService],
  entryComponents: [ModalConfirmComponent],
})
export class SharedModule {
}
